
  <div *ngIf="filteredObservationActions.length > 0" class="btn-group" dropdown>
    <button id="button-basic" dropdownToggle type="button" class="btn btn-sm btn-info dropdown-toggle"
            aria-controls="dropdown-basic">
            <i class="fas fa-lg fa-gear text-primary mr-1"></i> Actions <span class="caret"></span>
    </button>
    <ul id="dropdown-split" *dropdownMenu class="dropdown-menu"
      role="menu" aria-labelledby="button-split">
        <li role="menuitem" *ngFor="let action of filteredObservationActions"  ><a class="dropdown-item" (click)="changeObservationAction(action.Value)">{{ action.Label }}</a></li>

    </ul>
  </div>

